import {json} from "p3";
import common from "../common";
import GameScene from "../scenes/GameScene";

/**
 * @param {string} str
 * @param {boolean} [lineBreak=false]
 * @return {string}
 */
export function locale(str, lineBreak = false) {
    const language = common.config.language;
    const key = str.replace(/(\r\n|\n|\r)/gm, "");
    //console.log(key);
    let s = json("locale")[key];
    //console.log(s);

    if (s && s[language] && s[language] != "") {
        s = s[language];
    } else {
        //console.log(">>>>LOCALE NOT FOUND:", key);
        s = key;
        //s = json("locale_" + language)[key];
    }
    if (["za", "mecom", "apac"].indexOf(language) !== -1 && typeof s === "undefined") {
        s = json("locale")[key]['en'];
    }

    // if this is arabic text apply the convert function to correct the punctuation
    if (language === "ar") {
        s = convertAr(s);
    }

    return (typeof s !== "undefined") ? s + (lineBreak ? "\n" : "") : str;
}

export function convertAr(str) {
    const leftRegexp = /^(!|\.)+/gm
    const rightRegexp = /(!|\.)+$/gm
  
    const leftMatches = str.match(leftRegexp);
    if (leftMatches && leftMatches.length > 0) {
        return `${str.replace(leftRegexp, '')}${leftMatches[0]}\u200F`;
    }
  
    const rightMatches = str.match(rightRegexp);
    if (rightMatches && rightMatches.length > 0) {
        return `${str}\u200F`;
    }
    return str;
}

/**
 * Underlines texts with multiple lines
 * @param {PIXI.Text} label The text to underline
 * @param {PIXI.TextStyle} style The style of the text
 * @param {number|number[]|"all"} ["all"] The line(s) to underline, indexing at 0 (first line)
 */
 export function underlineMultilineText(label, style, lines = 'all') {
    const metrics = new PIXI.TextMetrics.measureText(label.text, style);
 
    //console.log(metrics);
 
    for (let i = 0; i < metrics.lineWidths.length; i++) {
        if (lines !== 'all' && lines !== i && (!Array.isArray(lines) || lines.indexOf(i) === -1)) continue;
 
        const width = metrics.lineWidths[i];
        const g = new PIXI.Graphics();
        g.beginFill(0xffffff);
 
         switch (style.align) {
             case 'left': 
                 g.drawRect(label.width * -label.anchor.x, metrics.lineHeight * (i + 1) - label.height * label.anchor.y, width, 1);
                 break;
             case 'center':
                 g.drawRect(width * -0.5, metrics.lineHeight * (i + 1) - label.height * label.anchor.y, width, 1);
                 break;
             case 'right':
                 g.drawRect(0, metrics.lineHeight * (i + 1) - label.height * label.anchor.y, -width, 1);
                 break;
         }
 
        g.endFill();
        label.addChild(g);
    }
 }

export function isrtl() {
    const language = common.config.language;
    return [
        "ar"
    ].indexOf(language) >= 0;
}

export function iswebfont(language) {
    language = language || common.config.language;
    return [
        "ar", "ru", "bg"
    ].indexOf(language) >= 0;
}

export function sensitiveUpperCase(text) {
    let output = "";
    const sensitiveCharacters = [["ß"]]; //"ẞ"]];
    for(let i in text) {
        let sensitiveChar = false;
        for (let j in sensitiveCharacters) {
            if (text[i] == sensitiveCharacters[j][0]) {
                sensitiveChar = sensitiveCharacters[j][1] || sensitiveCharacters[j][0];
                break;
            }
        }
        if (sensitiveChar == false) {
            output += text[i].toUpperCase();
        } else {
            output += sensitiveChar;
        }
    }
    return output;
}

/**
 * @param {PIXI.BitmapText|PIXI.Text} label
 * @param {number} maxWidth
 */
export function resizeLabelToFitText(label, maxWidth) {
    label.scale.set(1);
    const ratio = 1 / Math.max(1, label.width / maxWidth);
    label.scale.set(ratio);
}

/**
 * @param {[number]} weights 
 * @returns 
 */
export function weightedRand(weights) {
    let i;
    let sum = 0;
    let r = Math.random();
    
    for (i in weights) 
    {
        sum += weights[i];

        if (r <= sum) 
            return i;
    }
}

export function getMarketRegion(countryCode) {
    
    return {
        ad: "emea",
        ae: "emea",
        af: "emea",
        ag: "latam",
        ai: "latam",
        al: "emea",
        am: "emea",
        ao: "emea",
        aq: "emea",
        ar: "latam",
        as: "apac",
        at: "emea",
        au: "apac",
        aw: "latam",
        ax: "emea",
        az: "emea",
        ba: "emea",
        bb: "latam",
        bd: "apac",
        be: "emea",
        bf: "emea",
        bg: "emea",
        bh: "emea",
        bi: "emea",
        bj: "emea",
        bl: "emea",
        bm: "latam",
        bn: "apac",
        bo: "latam",
        br: "latam",
        bs: "latam",
        bt: "apac",
        bv: "emea",
        bw: "emea",
        by: "emea",
        bz: "latam",
        ca: "na",
        cc: "apac",
        cd: "emea",
        cf: "emea",
        cg: "emea",
        ch: "emea",
        ci: "emea",
        ck: "emea",
        cl: "latam",
        cm: "emea",
        cn: "apac",
        co: "latam",
        cr: "latam",
        cu: "latam",
        cv: "emea",
        cw: "emea",
        cx: "apac",
        cy: "emea",
        cz: "emea",
        de: "emea",
        dj: "emea",
        dk: "emea",
        dm: "latam",
        do: "latam",
        dz: "emea",
        ec: "latam",
        ee: "emea",
        eg: "emea",
        eh: "emea",
        er: "emea",
        es: "emea",
        et: "emea",
        fi: "emea",
        fj: "apac",
        fk: "latam",
        fm: "apac",
        fo: "emea",
        fr: "emea",
        ga: "emea",
        gb: "emea",
        gd: "latam",
        ge: "emea",
        gf: "emea",
        gg: "emea",
        gh: "emea",
        gi: "emea",
        gl: "emea",
        gm: "emea",
        gn: "emea",
        gp: "emea",
        gq: "emea",
        gr: "emea",
        gs: "latam",
        gt: "latam",
        gu: "apac",
        gw: "emea",
        gy: "latam",
        hk: "apac",
        hm: "emea",
        hn: "latam",
        hr: "emea",
        ht: "latam",
        hu: "emea",
        id: "apac",
        ie: "emea",
        il: "emea",
        im: "emea",
        in: "apac",
        io: "apac",
        iq: "emea",
        ir: "emea",
        is: "emea",
        it: "emea",
        je: "emea",
        jm: "latam",
        jo: "emea",
        jp: "apac",
        ke: "emea",
        kg: "emea",
        kh: "apac",
        ki: "apac",
        km: "emea",
        kn: "latam",
        kp: "apac",
        kr: "apac",
        kw: "emea",
        ky: "latam",
        kz: "emea",
        la: "apac",
        lb: "emea",
        lc: "latam",
        li: "emea",
        lk: "apac",
        lr: "emea",
        ls: "emea",
        lt: "emea",
        lu: "emea",
        lv: "emea",
        ly: "emea",
        ma: "emea",
        mc: "emea",
        md: "emea",
        me: "emea",
        mf: "emea",
        mg: "emea",
        mh: "apac",
        mk: "emea",
        ml: "emea",
        mm: "apac",
        mn: "apac",
        mo: "apac",
        mp: "apac",
        mq: "emea",
        mr: "emea",
        ms: "latam",
        mt: "emea",
        mu: "emea",
        mv: "apac",
        mw: "emea",
        mx: "latam",
        my: "apac",
        mz: "emea",
        na: "emea",
        nc: "emea",
        ne: "emea",
        nf: "apac",
        ng: "emea",
        ni: "latam",
        nl: "emea",
        no: "emea",
        np: "apac",
        nr: "apac",
        nu: "apac",
        nz: "apac",
        om: "emea",
        pa: "latam",
        pe: "latam",
        pf: "emea",
        pg: "apac",
        ph: "apac",
        pk: "apac",
        pl: "emea",
        pm: "emea",
        pn: "apac",
        pr: "latam",
        ps: "emea",
        pt: "emea",
        pw: "apac",
        py: "latam",
        qa: "emea",
        re: "emea",
        ro: "emea",
        rs: "emea",
        ru: "emea",
        rw: "emea",
        sa: "emea",
        sb: "apac",
        sc: "emea",
        sd: "emea",
        se: "emea",
        sg: "apac",
        sh: "emea",
        si: "emea",
        sk: "emea",
        sl: "emea",
        sm: "emea",
        sn: "emea",
        so: "emea",
        sr: "latam",
        ss: "emea",
        st: "emea",
        sv: "latam",
        sx: "emea",
        sy: "emea",
        sz: "emea",
        tc: "latam",
        td: "emea",
        tf: "emea",
        tg: "emea",
        th: "apac",
        tj: "emea",
        tk: "apac",
        tl: "apac",
        tm: "emea",
        tn: "emea",
        to: "apac",
        tr: "emea",
        tt: "latam",
        tv: "apac",
        tw: "apac",
        tz: "emea",
        ua: "emea",
        ug: "emea",
        um: "apac",
        us: "na",
        uy: "latam",
        uz: "emea",
        va: "emea",
        vc: "latam",
        ve: "latam",
        vg: "latam",
        vi: "latam",
        vn: "apac",
        vu: "apac",
        wf: "emea",
        ws: "apac",
        ye: "emea",
        yt: "emea",
        za: "emea",
        zm: "emea",
        zw: "emea"
    }[countryCode]
}

export function getMarket(countryCode) {
    return {
        af: "afghanistan",
        al: "albania",
        dz: "algeria",
        as: "american samoa",
        ad: "andorra",
        ao: "angola",
        ai: "anguilla",
        aq: "antarctica",
        ag: "antigua and barbuda",
        ar: "argentina",
        am: "armenia",
        aw: "aruba",
        au: "australia",
        at: "austria",
        az: "azerbaijan",
        bs: "bahamas",
        bh: "bahrain",
        bd: "bangladesh",
        bb: "barbados",
        by: "belarus",
        be: "belgium",
        bz: "belize",
        bj: "benin",
        bm: "bermuda",
        bt: "bhutan",
        bo: "bolivia",
        ba: "bosnia and herzegovina",
        bw: "botswana",
        bv: "bouvet island",
        br: "brazil",
        io: "british indian ocean territory",
        bn: "brunei darussalam",
        bg: "bulgaria",
        bf: "burkina faso",
        bi: "burundi",
        kh: "cambodia",
        cm: "cameroon",
        ca: "canada",
        cv: "cape verde",
        ky: "cayman islands",
        cf: "central african republic",
        td: "chad",
        cl: "chile",
        cn: "china",
        cx: "christmas island",
        cc: "cocos (keeling) islands",
        co: "colombia",
        km: "comoros",
        cg: "congo",
        cd: "congo, the democratic republic of the",
        ck: "cook islands",
        cr: "costa rica",
        ci: "côte d'ivoire",
        hr: "croatia",
        cu: "cuba",
        cy: "cyprus",
        cz: "czech republic",
        dk: "denmark",
        dj: "djibouti",
        dm: "dominica",
        do: "dominican republic",
        tp: "east timor",
        ec: "ecuador",
        eg: "egypt",
        sv: "el salvador",
        gq: "equatorial guinea",
        er: "eritrea",
        ee: "estonia",
        et: "ethiopia",
        fk: "falkland islands (malvinas)",
        fo: "faroe islands",
        fj: "fiji",
        fi: "finland",
        fr: "france",
        gf: "french guiana",
        pf: "french polynesia",
        tf: "french southern territories",
        ga: "gabon",
        gm: "gambia",
        ge: "georgia",
        de: "germany",
        gh: "ghana",
        gi: "gibraltar",
        gr: "greece",
        gl: "greenland",
        gd: "grenada",
        gp: "guadeloupe",
        gu: "guam",
        gt: "guatemala",
        gn: "guinea",
        gw: "guinea-bissau",
        gy: "guyana",
        ht: "haiti",
        hm: "heard island and mcdonald islands",
        va: "holy see (vatican city state)",
        hn: "honduras",
        hk: "hong kong",
        hu: "hungary",
        is: "iceland",
        in: "india",
        id: "indonesia",
        ir: "iran, islamic republic of",
        iq: "iraq",
        ie: "ireland",
        il: "israel",
        it: "italy",
        jm: "jamaica",
        jp: "japan",
        jo: "jordan",
        kz: "kazakstan",
        ke: "kenya",
        ki: "kiribati",
        kp: "korea, democratic people's republic of",
        kr: "korea, republic of",
        kw: "kuwait",
        kg: "kyrgyzstan",
        la: "lao people's democratic republic",
        lv: "latvia",
        lb: "lebanon",
        ls: "lesotho",
        lr: "liberia",
        ly: "libyan arab jamahiriya",
        li: "liechtenstein",
        lt: "lithuania",
        lu: "luxembourg",
        mo: "macau",
        mk: "macedonia, the former yugoslav republic of",
        mg: "madagascar",
        mw: "malawi",
        my: "malaysia",
        mv: "maldives",
        ml: "mali",
        mt: "malta",
        mh: "marshall islands",
        mq: "martinique",
        mr: "mauritania",
        mu: "mauritius",
        yt: "mayotte",
        mx: "mexico",
        fm: "micronesia, federated states of",
        md: "moldova, republic of",
        mc: "monaco",
        mn: "mongolia",
        ms: "montserrat",
        ma: "morocco",
        mz: "mozambique",
        mm: "myanmar",
        na: "namibia",
        nr: "nauru",
        np: "nepal",
        nl: "netherlands",
        an: "netherlands antilles",
        nc: "new caledonia",
        nz: "new zealand",
        ni: "nicaragua",
        ne: "niger",
        ng: "nigeria",
        nu: "niue",
        nf: "norfolk island",
        mp: "northern mariana islands",
        no: "norway",
        om: "oman",
        pk: "pakistan",
        pw: "palau",
        ps: "palestinian territory, occupied",
        pa: "panama",
        pg: "papua new guinea",
        py: "paraguay",
        pe: "peru",
        ph: "philippines",
        pn: "pitcairn",
        pl: "poland",
        pt: "portugal",
        pr: "puerto rico",
        qa: "qatar",
        re: "réunion",
        ro: "romania",
        ru: "russian federation",
        rw: "rwanda",
        sh: "saint helena",
        kn: "saint kitts and nevis",
        lc: "saint lucia",
        pm: "saint pierre and miquelon",
        vc: "saint vincent and the grenadines",
        ws: "samoa",
        sm: "san marino",
        st: "são tomé and príncipe",
        sa: "saudi arabia",
        sn: "senegal",
        sc: "seychelles",
        sl: "sierra leone",
        sg: "singapore",
        sk: "slovakia",
        si: "slovenia",
        sb: "solomon islands",
        so: "somalia",
        za: "south africa",
        gs: "south georgia and the south sandwich islands",
        es: "spain",
        lk: "sri lanka",
        sd: "sudan",
        sr: "suriname",
        sj: "svalbard and jan mayen",
        sz: "swaziland",
        se: "sweden",
        ch: "switzerland",
        sy: "syrian arab republic",
        tw: "taiwan, province of china",
        tj: "tajikistan",
        tz: "tanzania, united republic of",
        th: "thailand",
        tg: "togo",
        tk: "tokelau",
        to: "tonga",
        tt: "trinidad and tobago",
        tn: "tunisia",
        tr: "turkey",
        tm: "turkmenistan",
        tc: "turks and caicos islands",
        tv: "tuvalu",
        ug: "uganda",
        ua: "ukraine",
        ae: "united arab emirates",
        gb: "united kingdom",
        us: "united states",
        um: "united states minor outlying islands",
        uy: "uruguay",
        uz: "uzbekistan",
        vu: "vanuatu",
        ve: "venezuela",
        vn: "viet nam",
        vg: "virgin islands, british",
        vi: "virgin islands, u.s.",
        wf: "wallis and futuna",
        eh: "western sahara",
        ye: "yemen",
        yu: "yugoslavia",
        zm: "zambia",
        zw: "zimbabwe"
    }[countryCode];
}

export function getUserLanguage(countryCode) {
    return {
        "en": "en_uk",
        "ar": "ar_ae",
        "bg": "bg_bg",
        "cs": "cs_cz",
        "da": "da_dk",
        "nl": "nl_nl",
        "fr": "fr_fr",
        "de": "de_de",
        "hu": "hu_hu",
        "it": "it_it",
        "no": "no_no",
        "pl": "pl_pl",
        "pt": "pt_pt",
        "ro": "ro_ro",
        "ru": "ru_ru",
        "es": "es_es",
        "sv": "sv_sv",
        "tr": "tr_tr",
        "pt-br": "pt_pt",
        "es-419": "es_es"
    }[countryCode]
}

export function getUserMarketRegion() {
    const countryCode = getUserCountryCode().toLowerCase();
    return getMarketRegion(countryCode);
}

export function getUserMarket() {
    const countryCode = getUserCountryCode().toLowerCase();
    return getMarket(countryCode);
}

export function getUserCountryCode() {
    const lang = navigator.language.split("-")
    if (lang.length > 1) {
        return lang[1];
    } else {
        return lang[0];
    }
}

/**
 * @param {float} min 
 * @param {float} max 
 * @returns 
 */
export function getRandomFloat(min, max) {
    const str = (Math.random() * (max - min) + min).toFixed(1);
    return parseFloat(str);
}